import { PersistenceEvent } from '../persistenceEvents/persistenceEvent';
import { SyncEventType } from '../../enums/syncEventType';
import { CommActionItem } from '../../../interfaces/comm-action-item';


export class EventActionItemCreated implements PersistenceEvent {
  public readonly type = SyncEventType.AI_ISSUE_SUGGESTION_CREATED;
  private actionItem: CommActionItem;

  constructor(actionItem: CommActionItem) {
    this.actionItem = actionItem;
  }

  getPayload(): CommActionItem {
    return this.actionItem;
  }
}
